var vueCroppa = require('./vue-croppa')

module.exports = vueCroppa



// WEBPACK FOOTER //
// ./src/components/vue-croppa/index.js